export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (buyer_message, buyer_name, buyer_phone, canEdit, canViewSession, casualDrivers, customFieldsSorter, deliveryAddressLog, deliveryCost, deliveryOk, delivery_message, delivery_name, delivery_phone, directionsUrl, editingHistory, isCasualDriver, isLoaded, isSizeOption, label, order, renderDollars, renderName, renderTimestamp, toPay, viewDetails) {
      pug_mixins["render_address"] = pug_interp = function(address, order, suppressName, directionsUrl){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"address\"\u003E";
if (directionsUrl) {
pug_html = pug_html + "\u003Ca" + (" class=\"directions\""+" target=\"_blank\""+pug_attr("href", directionsUrl, true, true)) + "\u003E\u003Cimg src=\"images\u002Fnavigation.png\"\u003E\u003C\u002Fa\u003E";
}
if (! suppressName) {
pug_html = pug_html + "\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = address.fullName && address.fullName.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.fullName && address.fullName.lastName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (address.company) {
pug_html = pug_html + "\u003Cdiv class=\"company\"\u003E" + (pug_escape(null == (pug_interp = address.company) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E";
if (address.street) {
pug_html = pug_html + ((pug_escape(null == (pug_interp = address.street.number) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.street.name) ? "" : pug_interp)));
}
else {
pug_html = pug_html + (pug_escape(null == (pug_interp = address.addressLine1) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (address.addressLine2) {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E" + (pug_escape(null == (pug_interp = address.addressLine2) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (order && order.customField && order.customField.title == "Apartment Number, suite, etc") {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E" + (pug_escape(null == (pug_interp = order.customField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"city\"\u003E" + (pug_escape(null == (pug_interp = address.city) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.zipCode) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (! suppressName) {
pug_html = pug_html + "\u003Cdiv class=\"phone\"\u003E" + (pug_escape(null == (pug_interp = address.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (address.business) {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E\u003Cstrong\u003E(Business)\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (! order) {
pug_html = pug_html + "\u003Cdiv\u003ELoading...\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cdiv\u003E";
if (order.important) {
pug_html = pug_html + "\u003Cspan class=\"important-order\"\u003E\u003Ci class=\"fa-solid fa-star\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + ("\u003Cspan\u003ENumber " + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)));
if (order.business) {
pug_html = pug_html + "\n\u003Cstrong\u003E" + (pug_escape(null == (pug_interp = order.business) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E\n";
if (viewDetails) {
pug_html = pug_html + "\n\u003Ca class=\"print clickable\"\u003E(print)\u003C\u002Fa\u003E\n\u003Ca class=\"card clickable\"\u003E(card)\u003C\u002Fa\u003E\n\u003Ca class=\"map clickable\"\u003E(map)\u003C\u002Fa\u003E\n\u003Ca class=\"invoice clickable\"\u003E(invoice)\u003C\u002Fa\u003E";
}
if (canEdit) {
pug_html = pug_html + "\n\u003Ca class=\"edit clickable\"\u003E(edit)\u003C\u002Fa\u003E\n";
}
if (canViewSession && order.webSession) {
pug_html = pug_html + "\n\u003Ca" + (" class=\"clickable\""+pug_attr("href", `#/rrweb/${order.webSession}`, true, true)) + "\u003E(view session)\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyerInfo\"\u003E\u003Cdiv class=\"float-right\"\u003E\u003Cdiv class=\"actions-quick mobile-only\"\u003E";
if (!isLoaded && ! isCasualDriver) {
pug_html = pug_html + "\u003Cbutton class=\"delivery-load\" data-status=\"1\"\u003EAdd to load\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"email\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.email) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"phone\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address) {
pug_html = pug_html + "\u003Cdiv class=\"shipping-address\"\u003E\u003Cb\u003E\nDelivery address\n\u003C\u002Fb\u003E";
pug_mixins["render_address"](order.shippingInfo.shipmentDetails.address, order, false, directionsUrl);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (deliveryCost) {
pug_html = pug_html + "\u003Cdiv\u003EDelivery price:\u003Cb\u003E\n" + (pug_escape(null == (pug_interp = renderDollars(deliveryCost)) ? "" : pug_interp)) + "\u003C\u002Fb\u003E\u003C\u002Fdiv\u003E";
}
if (viewDetails) {
pug_html = pug_html + "\u003Cdiv class=\"lineItems\"\u003E";
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var lineItem = $$obj[pug_index0];
pug_html = pug_html + ("\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = renderName(lineItem)) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var option = $$obj[pug_index1];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["option",{size_and_price: isSizeOption(option)}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var option = $$obj[pug_index1];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["option",{size_and_price: isSizeOption(option)}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
var customTextFields = customFieldsSorter(lineItem.customTextFields || [])
var done = {};
pug_html = pug_html + "\u003Cdiv class=\"noteToFlorist\"\u003E";
// iterate customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var customTextField = $$obj[pug_index2];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate (customTextField.value || "").split("\n")
;(function(){
  var $$obj = (customTextField.value || "").split("\n");
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var val = $$obj[pug_index3];
pug_html = pug_html + "\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = val) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var val = $$obj[pug_index3];
pug_html = pug_html + "\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = val) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index2];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate (customTextField.value || "").split("\n")
;(function(){
  var $$obj = (customTextField.value || "").split("\n");
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var val = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = val) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var val = $$obj[pug_index4];
pug_html = pug_html + "\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = val) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

if (order.buyerNote) {
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003EBuyer note:\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = order.buyerNote) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"customTextFields\"\u003E";
// iterate customTextFields.filter((f) => ! done[f.title] && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => ! done[f.title] && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var customTextField = $$obj[pug_index5];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index5];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index0];
pug_html = pug_html + ("\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = renderName(lineItem)) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var option = $$obj[pug_index6];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["option",{size_and_price: isSizeOption(option)}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var option = $$obj[pug_index6];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["option",{size_and_price: isSizeOption(option)}], [false,true]), false, true)) + "\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
var customTextFields = customFieldsSorter(lineItem.customTextFields || [])
var done = {};
pug_html = pug_html + "\u003Cdiv class=\"noteToFlorist\"\u003E";
// iterate customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => f.title.toLowerCase().startsWith("note to florist") && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var customTextField = $$obj[pug_index7];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate (customTextField.value || "").split("\n")
;(function(){
  var $$obj = (customTextField.value || "").split("\n");
  if ('number' == typeof $$obj.length) {
      for (var pug_index8 = 0, $$l = $$obj.length; pug_index8 < $$l; pug_index8++) {
        var val = $$obj[pug_index8];
pug_html = pug_html + "\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = val) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index8 in $$obj) {
      $$l++;
      var val = $$obj[pug_index8];
pug_html = pug_html + "\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = val) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index7];
done[customTextField.title] = 1;
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate (customTextField.value || "").split("\n")
;(function(){
  var $$obj = (customTextField.value || "").split("\n");
  if ('number' == typeof $$obj.length) {
      for (var pug_index9 = 0, $$l = $$obj.length; pug_index9 < $$l; pug_index9++) {
        var val = $$obj[pug_index9];
pug_html = pug_html + "\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = val) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index9 in $$obj) {
      $$l++;
      var val = $$obj[pug_index9];
pug_html = pug_html + "\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = val) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

if (order.buyerNote) {
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003EBuyer note:\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = order.buyerNote) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"customTextFields\"\u003E";
// iterate customTextFields.filter((f) => ! done[f.title] && f.value)
;(function(){
  var $$obj = customTextFields.filter((f) => ! done[f.title] && f.value);
  if ('number' == typeof $$obj.length) {
      for (var pug_index10 = 0, $$l = $$obj.length; pug_index10 < $$l; pug_index10++) {
        var customTextField = $$obj[pug_index10];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index10 in $$obj) {
      $$l++;
      var customTextField = $$obj[pug_index10];
pug_html = pug_html + "\u003Cdiv class=\"customTextField\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug_escape(null == (pug_interp = customTextField.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"value\"\u003E" + (pug_escape(null == (pug_interp = customTextField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"lineItems\"\u003E";
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index11 = 0, $$l = $$obj.length; pug_index11 < $$l; pug_index11++) {
        var lineItem = $$obj[pug_index11];
pug_html = pug_html + "\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index12 = 0, $$l = $$obj.length; pug_index12 < $$l; pug_index12++) {
        var option = $$obj[pug_index12];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index12 in $$obj) {
      $$l++;
      var option = $$obj[pug_index12];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index11 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index11];
pug_html = pug_html + "\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index13 = 0, $$l = $$obj.length; pug_index13 < $$l; pug_index13++) {
        var option = $$obj[pug_index13];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index13 in $$obj) {
      $$l++;
      var option = $$obj[pug_index13];
if (option.selection != "No") {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = option.option) ? "" : pug_interp)) + " : " + (pug_escape(null == (pug_interp = option.selection) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (order.totals && order.totals.total) {
pug_html = pug_html + "\u003Cdiv class=\"totalPrice\"\u003E\u003Cp\u003ETotal order charge\n\n\u003Cb\u003E" + (pug_escape(null == (pug_interp = renderDollars(order.totals.total)) ? "" : pug_interp)) + "\u003C\u002Fb\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (order.orderHistory) {
var deliveryOk = { "Out for delivery": true, "Delivered": true };
pug_html = pug_html + "\u003Chr\u003E\u003Cdiv class=\"history\"\u003E";
if (viewDetails) {
if (! editingHistory) {
pug_html = pug_html + "\u003Cdiv class=\"float-right\"\u003E\u003Ca class=\"edit-history clickable\"\u003Eedit history\u003C\u002Fa\u003E\u003Cdiv class=\"deliveryAddressLog\"\u003E";
if (order.deliveryAddressLog) {
if (! deliveryAddressLog) {
pug_html = pug_html + "\u003Ca class=\"show-deliveryAddressLog clickable\"\u003Eview address log\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Col\u003E";
// iterate deliveryAddressLog
;(function(){
  var $$obj = deliveryAddressLog;
  if ('number' == typeof $$obj.length) {
      for (var pug_index14 = 0, $$l = $$obj.length; pug_index14 < $$l; pug_index14++) {
        var entry = $$obj[pug_index14];
pug_html = pug_html + "\u003Cli\u003E" + (pug_escape(null == (pug_interp = entry) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index14 in $$obj) {
      $$l++;
      var entry = $$obj[pug_index14];
pug_html = pug_html + "\u003Cli\u003E" + (pug_escape(null == (pug_interp = entry) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"float-right\"\u003E\u003Ca class=\"view-history clickable\"\u003Edone\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv style=\"clear: both\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Col\u003E";
// iterate order.orderHistory
;(function(){
  var $$obj = order.orderHistory;
  if ('number' == typeof $$obj.length) {
      for (var idx = 0, $$l = $$obj.length; idx < $$l; idx++) {
        var history = $$obj[idx];
if (viewDetails || deliveryOk[history.newStatus] || history.imageUrl) {
pug_html = pug_html + "\u003Cli\u003E";
if (editingHistory) {
pug_html = pug_html + "\u003Cdiv class=\"float-right\"\u003E\u003Ca" + (" class=\"delete-history clickable\""+pug_attr("data-idx", idx, true, true)) + "\u003Edelete\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + ((pug_escape(null == (pug_interp = history.newStatus) ? "" : pug_interp)) + " by " + (pug_escape(null == (pug_interp = history.createdBy) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = renderTimestamp(history.createdTs / 1000)) ? "" : pug_interp)));
if (history.imageUrl) {
pug_html = pug_html + "\u003Cimg" + (" class=\"lightboxImg\""+pug_attr("src", history.imageUrl, true, true)+" style=\"image-orientation: from-image\"") + "\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var idx in $$obj) {
      $$l++;
      var history = $$obj[idx];
if (viewDetails || deliveryOk[history.newStatus] || history.imageUrl) {
pug_html = pug_html + "\u003Cli\u003E";
if (editingHistory) {
pug_html = pug_html + "\u003Cdiv class=\"float-right\"\u003E\u003Ca" + (" class=\"delete-history clickable\""+pug_attr("data-idx", idx, true, true)) + "\u003Edelete\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + ((pug_escape(null == (pug_interp = history.newStatus) ? "" : pug_interp)) + " by " + (pug_escape(null == (pug_interp = history.createdBy) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = renderTimestamp(history.createdTs / 1000)) ? "" : pug_interp)));
if (history.imageUrl) {
pug_html = pug_html + "\u003Cimg" + (" class=\"lightboxImg\""+pug_attr("src", history.imageUrl, true, true)+" style=\"image-orientation: from-image\"") + "\u003E";
}
pug_html = pug_html + "\u003C\u002Fli\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E";
}
pug_mixins["actions"] = pug_interp = function(actions){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate (actions)
;(function(){
  var $$obj = (actions);
  if ('number' == typeof $$obj.length) {
      for (var pug_index16 = 0, $$l = $$obj.length; pug_index16 < $$l; pug_index16++) {
        var v = $$obj[pug_index16];
pug_html = pug_html + "\u003Cbutton" + (" class=\"action\""+pug_attr("data-status", v, true, true)+pug_attr("disabled", (order.currentStatus == v), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index16 in $$obj) {
      $$l++;
      var v = $$obj[pug_index16];
pug_html = pug_html + "\u003Cbutton" + (" class=\"action\""+pug_attr("data-status", v, true, true)+pug_attr("disabled", (order.currentStatus == v), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
    }
  }
}).call(this);

};
if (viewDetails) {
pug_html = pug_html + "\u003Chr\u003E\u003Cdiv class=\"actions\"\u003E";
pug_mixins["actions"](["Ready to make", "Made", "Out for delivery", "Delivered", "Cancelled"]);
// iterate casualDrivers
;(function(){
  var $$obj = casualDrivers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index17 = 0, $$l = $$obj.length; pug_index17 < $$l; pug_index17++) {
        var casualDriver = $$obj[pug_index17];
pug_html = pug_html + "\u003Cbutton" + (" class=\"action\""+pug_attr("data-driver", casualDriver.username, true, true)) + "\u003EGive to " + (pug_escape(null == (pug_interp = casualDriver.displayName) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index17 in $$obj) {
      $$l++;
      var casualDriver = $$obj[pug_index17];
pug_html = pug_html + "\u003Cbutton" + (" class=\"action\""+pug_attr("data-driver", casualDriver.username, true, true)) + "\u003EGive to " + (pug_escape(null == (pug_interp = casualDriver.displayName) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
    }
  }
}).call(this);

if (toPay) {
pug_html = pug_html + "\u003Cbutton class=\"action\" data-status=\"Paid\"\u003EPaid\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003Cbutton class=\"action\" data-sms=\"1\"\u003ESMS\u003C\u002Fbutton\u003E\u003Cbutton class=\"action mobile-only\" data-phone=\"1\"\u003ECall\u003C\u002Fbutton\u003E\u003Cbutton class=\"action mobile-only\" data-photo=\"camera\"\u003EPhoto\u003C\u002Fbutton\u003E\u003Cbutton class=\"action\" data-photo=\"image\"\u003EImage\u003C\u002Fbutton\u003E";
if (order.important) {
pug_html = pug_html + "\u003Cbutton class=\"action\" data-important=\"0\"\u003ERemove important\u003C\u002Fbutton\u003E";
}
else {
pug_html = pug_html + "\u003Cbutton class=\"action\" data-important=\"1\"\u003EMark important\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003Cdiv\u003E\u003Cinput name=\"other\" placeholder=\"Other note\"\u003E\u003Cbutton class=\"action\"\u003EOther\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
if (!isLoaded) {
pug_html = pug_html + "\u003Cbutton class=\"delivery-load desktop-only\" data-status=\"1\"\u003EAdd to load\u003C\u002Fbutton\u003E";
}
else {
pug_html = pug_html + "\u003Cbutton class=\"delivery-load\" data-status=\"0\"\u003ERemove from load\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Chr\u003E\u003Cdiv class=\"actions\"\u003E";
if (!isCasualDriver) {
pug_mixins["actions"](["Out for delivery", "Delivered"]);
pug_html = pug_html + "\u003Cbutton class=\"action\" data-sms=\"1\"\u003ESMS\u003C\u002Fbutton\u003E\u003Cbutton class=\"action mobile-only\" data-phone=\"1\"\u003ECall\u003C\u002Fbutton\u003E\u003Cbutton class=\"action mobile-only\" data-photo=\"camera\"\u003EPhoto\u003C\u002Fbutton\u003E\u003Cbutton class=\"action\" data-photo=\"image\"\u003EImage\u003C\u002Fbutton\u003E";
if (! isLoaded) {
pug_html = pug_html + "\u003Cbutton class=\"delivery-load desktop-only\" data-status=\"1\"\u003EAdd to load\u003C\u002Fbutton\u003E";
}
else {
pug_html = pug_html + "\u003Cbutton class=\"delivery-load\" data-status=\"0\"\u003ERemove from load\u003C\u002Fbutton\u003E";
}
}
else {
pug_mixins["actions"](["Delivered"]);
pug_html = pug_html + "\u003Cbutton class=\"action\" data-sms=\"1\"\u003ESMS\u003C\u002Fbutton\u003E\u003Cbutton class=\"action mobile-only\" data-phone=\"1\"\u003ECall\u003C\u002Fbutton\u003E\u003Cbutton class=\"action mobile-only\" data-photo=\"camera\"\u003EPhoto\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"sms-modal js-modal\"\u003E\u003Cdiv class=\"title\"\u003ESend SMS\u003C\u002Fdiv\u003E\u003Cdiv class=\"send-sms content\"\u003E\u003Cform class=\"with-validation\"\u003E";
if (buyer_phone) {
pug_html = pug_html + "\u003Cdiv\u003E";
var label = buyer_phone == delivery_phone ? "Buyer/delivery phone" : "Buyer phone"
pug_html = pug_html + "\u003Cdiv class=\"label\"\u003E\u003Clabel\u003E" + (pug_escape(null == (pug_interp = label) ? "" : pug_interp)) + "\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"input\"\u003E\u003Cinput" + (" class=\"form-control\""+" name=\"buyer_phone\""+pug_attr("value", buyer_phone, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ctextarea class=\"form-control\" name=\"buyer_message\"\u003E" + (pug_escape(null == (pug_interp = buyer_message) ? "" : pug_interp)) + "\u003C\u002Ftextarea\u003E";
}
if (delivery_phone && delivery_phone != buyer_phone) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cdiv class=\"label\"\u003E\u003Clabel\u003EDelivery phone\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"input\"\u003E\u003Cinput" + (" class=\"form-control\""+" name=\"delivery_phone\""+pug_attr("value", delivery_phone, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ctextarea class=\"form-control\" name=\"delivery_message\" rows=\"4\"\u003E" + (pug_escape(null == (pug_interp = delivery_message) ? "" : pug_interp)) + "\u003C\u002Ftextarea\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"buttons\"\u003E\u003Cbutton class=\"form-control send-button\"\u003ESend\u003C\u002Fbutton\u003E\u003Cbutton class=\"form-control js-modal-trigger\"\u003ECancel\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"phone-modal js-modal\"\u003E\u003Cdiv class=\"title\"\u003ECall buyer\u002Frecipient\u003C\u002Fdiv\u003E\u003Cdiv class=\"call-client content\"\u003E\u003Cform\u003E";
if (buyer_phone) {
pug_html = pug_html + "\u003Cdiv\u003E";
var label = buyer_phone == delivery_phone ? "Buyer/delivery" : "Buyer"
pug_html = pug_html + "\u003Cdiv class=\"label\"\u003E\u003Clabel\u003E" + (pug_escape(null == (pug_interp = label) ? "" : pug_interp)) + "\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"input\"\u003E\u003Ca" + (" class=\"form-control\""+pug_attr("href", `tel:${buyer_phone}`, true, true)) + "\u003E\u003Ci class=\"fa fa-phone\"\u003E\u003C\u002Fi\u003E\n" + (pug_escape(null == (pug_interp = buyer_phone) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = buyer_name || "") ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (delivery_phone && delivery_phone != buyer_phone) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Cdiv class=\"label\"\u003E\u003Clabel\u003ERecipient\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"input\"\u003E\u003Ca" + (" class=\"form-control\""+pug_attr("href", `tel:${delivery_phone}`, true, true)) + "\u003E\u003Ci class=\"fa fa-phone\"\u003E\u003C\u002Fi\u003E\n" + (pug_escape(null == (pug_interp = delivery_phone) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = delivery_name || "") ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"buttons\"\u003E\u003Cbutton class=\"form-control js-modal-trigger\"\u003ECancel\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"photo-modal js-modal\"\u003E\u003Cdiv class=\"title\"\u003EAttach photo\u003C\u002Fdiv\u003E\u003Cdiv class=\"attach-photo content\"\u003E\u003Cform\u003E\u003Cinput class=\"form-control photo\" type=\"file\" accept=\"image\u002F*\" capture=\"environment\"\u003E\u003Cdiv class=\"buttons\"\u003E\u003Cbutton class=\"form-control js-modal-trigger\"\u003ECancel\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"image-modal js-modal\"\u003E\u003Cdiv class=\"title\"\u003E\u003Cdiv\u003E\u003Ca class=\"copy-image-url clickable\"\u003ECopy image URL\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Ci class=\"fa-solid fa-xmark js-modal-trigger float-right huge-button\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cimg src=\"#\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "buyer_message" in locals_for_with ?
        locals_for_with.buyer_message :
        typeof buyer_message !== 'undefined' ? buyer_message : undefined, "buyer_name" in locals_for_with ?
        locals_for_with.buyer_name :
        typeof buyer_name !== 'undefined' ? buyer_name : undefined, "buyer_phone" in locals_for_with ?
        locals_for_with.buyer_phone :
        typeof buyer_phone !== 'undefined' ? buyer_phone : undefined, "canEdit" in locals_for_with ?
        locals_for_with.canEdit :
        typeof canEdit !== 'undefined' ? canEdit : undefined, "canViewSession" in locals_for_with ?
        locals_for_with.canViewSession :
        typeof canViewSession !== 'undefined' ? canViewSession : undefined, "casualDrivers" in locals_for_with ?
        locals_for_with.casualDrivers :
        typeof casualDrivers !== 'undefined' ? casualDrivers : undefined, "customFieldsSorter" in locals_for_with ?
        locals_for_with.customFieldsSorter :
        typeof customFieldsSorter !== 'undefined' ? customFieldsSorter : undefined, "deliveryAddressLog" in locals_for_with ?
        locals_for_with.deliveryAddressLog :
        typeof deliveryAddressLog !== 'undefined' ? deliveryAddressLog : undefined, "deliveryCost" in locals_for_with ?
        locals_for_with.deliveryCost :
        typeof deliveryCost !== 'undefined' ? deliveryCost : undefined, "deliveryOk" in locals_for_with ?
        locals_for_with.deliveryOk :
        typeof deliveryOk !== 'undefined' ? deliveryOk : undefined, "delivery_message" in locals_for_with ?
        locals_for_with.delivery_message :
        typeof delivery_message !== 'undefined' ? delivery_message : undefined, "delivery_name" in locals_for_with ?
        locals_for_with.delivery_name :
        typeof delivery_name !== 'undefined' ? delivery_name : undefined, "delivery_phone" in locals_for_with ?
        locals_for_with.delivery_phone :
        typeof delivery_phone !== 'undefined' ? delivery_phone : undefined, "directionsUrl" in locals_for_with ?
        locals_for_with.directionsUrl :
        typeof directionsUrl !== 'undefined' ? directionsUrl : undefined, "editingHistory" in locals_for_with ?
        locals_for_with.editingHistory :
        typeof editingHistory !== 'undefined' ? editingHistory : undefined, "isCasualDriver" in locals_for_with ?
        locals_for_with.isCasualDriver :
        typeof isCasualDriver !== 'undefined' ? isCasualDriver : undefined, "isLoaded" in locals_for_with ?
        locals_for_with.isLoaded :
        typeof isLoaded !== 'undefined' ? isLoaded : undefined, "isSizeOption" in locals_for_with ?
        locals_for_with.isSizeOption :
        typeof isSizeOption !== 'undefined' ? isSizeOption : undefined, "label" in locals_for_with ?
        locals_for_with.label :
        typeof label !== 'undefined' ? label : undefined, "order" in locals_for_with ?
        locals_for_with.order :
        typeof order !== 'undefined' ? order : undefined, "renderDollars" in locals_for_with ?
        locals_for_with.renderDollars :
        typeof renderDollars !== 'undefined' ? renderDollars : undefined, "renderName" in locals_for_with ?
        locals_for_with.renderName :
        typeof renderName !== 'undefined' ? renderName : undefined, "renderTimestamp" in locals_for_with ?
        locals_for_with.renderTimestamp :
        typeof renderTimestamp !== 'undefined' ? renderTimestamp : undefined, "toPay" in locals_for_with ?
        locals_for_with.toPay :
        typeof toPay !== 'undefined' ? toPay : undefined, "viewDetails" in locals_for_with ?
        locals_for_with.viewDetails :
        typeof viewDetails !== 'undefined' ? viewDetails : undefined));
    ;;return pug_html;}